export default __webpack_public_path__ + "static/media/img3.538e04a7.png";